import { config } from "../constants";
import {Locale} from "./locale";

export class Routing {
  public static JoinURLParts(...parts: string[]): string {
    return parts
      .map((part) => part.replace(/^\/+|\/+$/g, ''))
      .join('/');
  }
  public static ROUTES: any = config.routing;
  static HOST: string = config.routingHost;
  _lang: string = Locale.getInstance().getLanguage();
  constructor() {}

  public getCurrentPage(): string {
    let hostParts = window?.location?.href?.split("?") || [""];
    return hostParts[0];
  }

  public getLanguage(): string {
    return this._lang;
  }

  public goToLastPage(): void {
    if (document.referrer.startsWith(Routing.HOST)) {
      window.location.href = document.referrer;
    } else {
      window.location.href = Routing.HOST;
    }
  }

  public goTo(location: string): void {
    window.location.href = location;
  }

  public getRouteKeyFromCurrentLocation(lang?: string): string {
    let ln = lang || this.getLanguage();
    let currentRoute = this.getCurrentPage();
    let routes = Routing.ROUTES[ln];
    let ident: string = "";

    for (let k in routes) {
      if (currentRoute === Routing.JoinURLParts(Routing.HOST, routes[k])) {
        ident = k;
        break;
      }
    }

    return ident;
  }
}
